export default __webpack_public_path__ + "images/943e68fc87a3f8b086816a196ee6dfd9.png";